import React, { useEffect } from 'react';
import Field from '../../../fields/Field';
import FieldPassword from '../../../fields/FieldPassword';
import FieldNumber from '../../../fields/FieldNumber';
import FieldCheckbox from '../../../fields/FieldCheckbox';
import FieldSelect from '../../../fields/FieldSelect';
import { getTranslation } from '../../../../lang/main';

function EditPostmanFields(props) {
    const {
        formData,
        onFieldUpdate,
        onUpdateFormDataBulk,
        updateFormData,
        defaultIsRequired,
        postmanFieldList,
        editPostman,
        showForm,
    } = props;
    let { fieldRefs } = props;

    let fields = [];

    let selectedPostmanOption = editPostman.InternalItemID;

    if (selectedPostmanOption) {
        const parameters = postmanFieldList[selectedPostmanOption]['parameters'];

        fields = Object.keys(parameters).map((parameter) => {

            // const labelKey = parameters[parameter]['Label'];
            const labelKey = parameters[parameter]['Key'];

            const translatedLabel = getTranslation(`FIELD.POSTMAN.${labelKey}.${window.locale}`);
            const defaultLabel = getTranslation(`FIELD.POSTMAN.${labelKey}`);

            let finalTranslatedLabel = labelKey;
            if (translatedLabel !== `FIELD.POSTMAN.${labelKey}.${window.locale}`) {
                finalTranslatedLabel = translatedLabel;
            }
            else if (defaultLabel !== `FIELD.POSTMAN.${labelKey}`) {
                finalTranslatedLabel = defaultLabel;
            }

            return {
                key: parameter,
                InternalItemID: selectedPostmanOption,
                title: postmanFieldList[selectedPostmanOption]['name'],
                placeholder: parameters[parameter]['Key'],
                type: parameters[parameter]['Type'],
                label: finalTranslatedLabel,
                value: editPostman[parameter] ? editPostman[parameter] : '',
                options:
                    parameters[parameter]['Type'] === 'select'
                        ? parameters[parameter]['Options'].map((key) => {
                              return {
                                  value: key,
                                  label: key,
                              };
                          })
                        : null,
            };
        });
    }

    // useEffect(() => {
    //     // omg we should not do this!
    //     let restoreFieldsForUpdate = {};
    //     fields.forEach((field) => {
    //         restoreFieldsForUpdate[field.key] = field.value;
    //     });
    //
    //     onUpdateFormDataBulk({
    //         ID: editPostman.ID,
    //         ...restoreFieldsForUpdate,
    //     });
    // }, [showForm]);

    return (
        <>
            {fields.length > 0 && (
                <>
                    {fields.map((field, index) => {
                        let fieldProps = {
                            key: index,
                            required: field.required,
                            label: field.label,
                            animatedLabel: field.label,
                            placeholder: field.placeholder,
                            name: field.key,
                            value: formData[field.key],
                            onChange: onFieldUpdate,
                        };

                        if (field.type === 'text') {
                            return (
                                <Field
                                    {...fieldProps}
                                    ref={(r) => (fieldRefs[field.key] = r)}
                                />
                            );
                        }

                        if (field.type === 'password') {
                            return (
                                <FieldPassword
                                    {...fieldProps}
                                    ref={(r) => (fieldRefs[field.key] = r)}
                                />
                            );
                        }

                        if (field.type === 'decimal') {
                            return (
                                <FieldNumber
                                    {...fieldProps}
                                    ref={(r) => (fieldRefs[field.key] = r)}
                                    allowDecimals={true}
                                />
                            );
                        }

                        if (field.type === 'boolean') {
                            const fieldValue = fieldProps.value !== null ? fieldProps.value : false;

                            return (
                                <FieldCheckbox
                                    {...fieldProps}
                                    ref={(r) => (fieldRefs[field.key] = r)}
                                    checked={fieldValue === true}
                                    value={true}
                                    onChange={e => updateFormData(fieldProps.name, !fieldValue)}
                                />
                            );
                        }

                        if (field.type === 'select') {
                            return (
                                <FieldSelect
                                    {...fieldProps}
                                    ref={(r) => (fieldRefs[field.key] = r)}
                                    options={field.options}
                                />
                            );
                        }
                    })}
                </>
            )}
        </>
    );
}

// default props
EditPostmanFields.defaultProps = {
    defaultIsRequired: false,
};

export default EditPostmanFields;
